<section class="container">
  <div class="container-batch batch pb-20">
    <h1 class="batch-title">Lotes Automáticos</h1>
    <app-header-repasse
      [bankOpts]="bankOpts"
      [channelOpts]="channelOpts"
      (addConfigEvent)="addBatchConfig($event, 'Automatic')"
    ></app-header-repasse>
    <div class="vw-60 min-w-420">
      <div class="mb-10 batch-header header">
        <ng-container *ngFor="let item of automaticHeaderOptions">
          <div
            class="header-box box d-flex align-center flex-{{
              item.flexSize
            }} justify-{{ item.justify }}"
          >
            <span class="box-text">
              {{ item.label }}
            </span>
          </div>
        </ng-container>
      </div>
      <ng-container *ngFor="let batch of automaticBatches">
        <app-listagem-repasse
          [invoiceOpts]="invoiceOpts"
          [contractOpts]="contractOpts"
          [paymentOpts]="paymentOpts"
          [batchConfig]="batch"
          [type]="ConfigTransferEnum.Automatic"
          (deleteBatchConfigEvent)="
            handleDeleteBatchConfig($event, 'Automatic')
          "
        ></app-listagem-repasse>
      </ng-container>
      <ng-container *ngIf="automaticBatches.length < 1">
        <app-empty-card
          text="Não há configurações automáticas"
          minWidth="420px"
        ></app-empty-card>
      </ng-container>
    </div>
  </div>

  <hr />

  <div class="container-batch batch pt-10">
    <h1 class="batch-title">Lotes Repasse</h1>
    <app-header-repasse
      [bankOpts]="bankOpts"
      [channelOpts]="channelOpts"
      (addConfigEvent)="addBatchConfig($event, 'Manual')"
    ></app-header-repasse>
    <div class="vw-80">
      <div class="mb-10 batch-header header min-w-950">
        <ng-container *ngFor="let item of manualHeaderOptions">
          <div
            class="header-box box d-flex align-center plr-5 flex-{{
              item.flexSize
            }} justify-{{ item.justify }}"
          >
            <span class="box-text">
              {{ item.label }}
            </span>
          </div>
        </ng-container>
      </div>
      <ng-container *ngFor="let batch of manualBatches">
        <app-listagem-repasse
          [invoiceOpts]="invoiceOpts"
          [contractOpts]="contractOpts"
          [paymentOpts]="paymentOpts"
          [batchConfig]="batch"
          [type]="ConfigTransferEnum.Manual"
          (deleteBatchConfigEvent)="handleDeleteBatchConfig($event, 'Manual')"
        ></app-listagem-repasse>
      </ng-container>
      <ng-container *ngIf="manualBatches.length < 1">
        <app-empty-card
          text="Não há configurações manuais"
          minWidth="950px"
        ></app-empty-card>
      </ng-container>
    </div>
  </div>
</section>
